import { Text } from '@react-three/drei';
import { DropInstructions } from './drop-instructions';

export function HUD({ score, balls }: { score: number; balls: number }) {
  return (
    <>
      <Text position={[9, 8, 0]} fontSize={1} color="#ffffff" anchorX="center" anchorY="middle">
        {score}
      </Text>

      {balls > 0 && (
        <group position={[-11, 8, 0]}>
          {[...Array(balls)].map((_, i) => (
            <mesh key={i} position={[i * 1.2, 0, 0]}>
              <sphereGeometry args={[0.4, 16, 16]} />
              <meshStandardMaterial color="#ff4444" />
            </mesh>
          ))}
        </group>
      )}

      <DropInstructions />
    </>
  );
}
